






























import { IBooking } from '@/models/IBooking.model';
import { IPark } from '@/models/IPark.model';
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment'
import getBookingHoursByDDMMYYYY from '../../../helpers/getBookingHoursByDDMMYYY.helper';
import { IUser } from '@/models/IUser.model';
@Component({
  components: {},
})
export default class InputBookingHour extends Vue {

    @Prop()
    public placeholder!: string;

    @Prop()
    public bookings!: IBooking[];

    @Prop()
    public park!: IPark;

    @Prop()
    public date!: Date;

    @Prop()
    public clientType!: string;

    public clientType2 = '';

    public label = 'Elija la hora de reserva';
    public icon = 'query_builder';
    public error = '';
    public hour = '';

    public get hours(): string[]{
       const ddmmyyyy = moment(this.date).format('DDMMYYYY');
       const park = this.park;
       const cc = (this.$store.state.user as IUser).cc_number;
       const bookings = (this.$store.state.bookings as IBooking[]);
       return getBookingHoursByDDMMYYYY(cc, ddmmyyyy, bookings, park, this.clientType);
    }

    private mounted(){
      this.clientType2 = this.$store.state.clientType;
    }


     onChange($text) {
      console.log($text)
        if($text.length === 0){
            this.error = 'Hora invalida';
        } else {
          this.$emit('nChange', $text)
            this.error = '';
        }
    }


}
